/* eslint-disable */
import PropTypes from 'prop-types';
import { ESTADOS, PROCESOS_ESPECIFICOS, TIPO_MONITOREOS } from 'constants/nombresCatalogos';
import {
  Input,
  Table,
  Button,
  SelectTamanoPagina,
  Checkbox,
  Tooltip // ,
  // ModalVistaQR
} from 'components';
import { DATE_FORMAT_DATE_PICKER } from 'constants/dateFormat';
import {
  DownloadOutlined,
  EyeOutlined,
  EditOutlined,
  CloseCircleOutlined,
  QrcodeOutlined,
  BellOutlined
} from '@ant-design/icons';
import {
  getMonitoreosEspectacularesActaInicio,
  postEditMonEspectaculares
} from 'actions/espectaculares.actions';
import { getPdfActa } from 'actions/pdf.actions';
import { selectActaInicio } from 'selectors/monitoreosEspectaculares.selector';
import { selectMenuState } from 'selectors/auth.selector';
import { getMenuPermissions } from 'utils/getMenuPermissions';
import {
  NOMBRE_MENU_ESPECTACULARES,
  NOMBRE_SUBMENU_ACTAS_INICIO,
  NOMBRE_MENU_PERMISO_CAPTURAR,
  NOMBRE_MENU_PERMISO_EDITAR,
  NOMBRE_MENU_PERMISO_ELIMINAR,
  NOMBRE_MENU_PERMISO_QR,
  NOMBRE_MENU_PERMISO_NOTIFICAR,
  NOMBRE_MENU_PERMISO_VALIDAR
} from 'constants/menuNombres';
import { DOWNLOAD_TYPES } from 'constants/downloadTypes';
import { filterList } from 'utils/filterList';
import { getFolioNumber } from 'utils/getFolioNumber';
import { selectCatalogByName, selectCatalogs } from 'selectors/catalogos.selectors';
import { MONITOREOS_ESPECTACULARES, ACTA_INICIO } from 'constants/tipoMonitoreos';
import { PDF_ACTA_INICIO } from 'constants/pdfTypes';
import { downloadExcelActas } from 'actions/files.actions';
import { base64toBlob } from 'utils/file';
import './TablaMonitoreos.scss';
import { DatePicker, message, Spin } from 'antd';
import { useEffect, useMemo, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useDebounce } from 'hooks/useDebounce';
import { DescripcionEnlacesModal } from 'components/GeneracionEnlaces/DescripcionEnlacesModal';
import { ModalPdf, DescargaPDF } from 'components/ModalPdf/ModalPdf';
import * as MensGrales from 'constants/MensajesGenerales';
import { generateId } from 'utils/idGenerator';
import { useLocation } from 'react-router-dom';
import CancelModalMonitoring from 'components/CancelModalMonitoring/CancelModalMonitoring';
import ModalNotificarPartido from 'components/ModalNotificarPartido/ModalNotificarPartido';
import { TIPO_ACTA_INICIO, PARCIALMENTE_NOTIFICADO, NOTIFICADO } from 'constants/notificarPartidos';
import ModalCodigoQR from './ModalCodigoQR/ModalCodigoQR';
import * as actasService from '../../../../services/espectacularesActas';
import ModalFormularioActaInicio from '../ModalFormularioActaInicio/ModalFormularioActaInicio';
import ModalFormularioActaCierre from '../../../MonitoreoActaCierre/components/ModalFormularioActaCierre/ModalFormularioActaCierre';
// import ModalCancelacion from '../ModalCancelacion/ModalCancelacion';

import { useSetAddImages } from '../hooks/useSetAddImages';

const DEBOUNCE_TIME_FILTER = 1000;
let timeoutId = null;

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const TablaMonitoreos = ({ mainFilters, seleccion, onProcesarTodoChange }) => {
  const query = useQuery();
  const folioActaInicio = query.get('folio');
  const filtersRef = useRef({});
  const notificar = useRef({});
  const [filters, setFilters] = useState({});
  const procesosEspe = useSelector(selectCatalogByName(PROCESOS_ESPECIFICOS));
  const estados = useSelector(selectCatalogByName(ESTADOS));
  const catMonitoreos = useSelector(selectCatalogByName(TIPO_MONITOREOS));
  const menu = useSelector(selectMenuState);
  const catalogos = useSelector(selectCatalogs);
  const [isModalPdfOpen, setIsModalPdfOpen] = useState(false);
  const [isActaId, setIsActaId] = useState(null);
  const [isMonitoreoId, setIsMonitoreoId] = useState(null);
  const [loadingImages, setLoadingImages] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [downloadingExcel, setDownloadingExcel] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [isModalVistaQROpen, setIsModalVistaQROpen] = useState(false);
  const [isFormModalVisible, setIsFormModalVisible] = useState(false);
  const [dataQR, setDataQR] = useState(null);
  const [pdfActa, setPdfActa] = useState(null);
  const [monitoreoCancelar, setMonitoreoCancelar] = useState(null);
  const [successCancelar, setSuccessCancelar] = useState(false);
  const [folioCancelar, setFolioCancelar] = useState(null);
  const [checkedListDescargas, setCheckedListDescargas] = useState([]);
  const [checkedListNotificar, setCheckedListNotificar] = useState([]);
  const [disableButtonNotificar, setDisableButtonNotificar] = useState(true);
  const [visibleModalNotificar, setVisibleModalNotificar] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [dataFromQR, setDataFromQR] = useState(null);
  const [visibleFormModalActaCierre, setVisibleFormModalActaCierre] = useState(false);
  const { data: usuario } = useSelector((state) => state.validarUsuario);

  const catalogosStore = {};
  catalogosStore.procesosEspe = procesosEspe;
  catalogosStore.estados = estados;
  catalogosStore.catBeneficiados = catalogos.data.beneficiados;
  catalogosStore.catMonitoreos = catMonitoreos;

  const applyFilter = useDebounce((fields) => setFilters(fields), DEBOUNCE_TIME_FILTER);
  const dispatch = useDispatch();

  const { loading, data } = useSelector(selectActaInicio);

  const allOptions = data;
  const checkAllOptionsDescargas =
    allOptions.length === checkedListDescargas.length && allOptions.length !== 0;
  const indeterminateDescargas =
    checkedListDescargas.length > 0 && checkedListDescargas.length < allOptions.length;
  const allOptionsNotificar = data.filter(
    (monitoreo) =>
      monitoreo.estatusActa === 'Validado' || monitoreo.actas[0]?.actaNotificada !== NOTIFICADO
  );
  const notificadosParcialmente = allOptionsNotificar.filter(
    (item) => item.actas[0]?.actaNotificada === PARCIALMENTE_NOTIFICADO
  );
  const checkAllOptionsNotificar =
    allOptionsNotificar.length === checkedListNotificar.length && allOptionsNotificar.length !== 0;
  const indeterminateNotificar =
    (checkedListNotificar.length > 0 && checkedListNotificar.length < allOptionsNotificar.length) ||
    notificadosParcialmente?.length > 0;

  const tienePermisoValidar = getMenuPermissions(
    menu,
    NOMBRE_MENU_ESPECTACULARES,
    NOMBRE_SUBMENU_ACTAS_INICIO,
    NOMBRE_MENU_PERMISO_VALIDAR
  );

  const tienePermisoEditar = getMenuPermissions(
    menu,
    NOMBRE_MENU_ESPECTACULARES,
    NOMBRE_SUBMENU_ACTAS_INICIO,
    NOMBRE_MENU_PERMISO_EDITAR
  );

  const tienePermisoNotificar = getMenuPermissions(
    menu,
    NOMBRE_MENU_ESPECTACULARES,
    NOMBRE_SUBMENU_ACTAS_INICIO,
    NOMBRE_MENU_PERMISO_NOTIFICAR
  );

  const showTotal = (total, range) => {
    return `Mostrando del ${range[0]} al ${range[1]} de ${total} registros`;
  };

  const [pagination, setPagination] = useState({
    position: ['bottomRight'],
    showQuickJumper: true,
    size: 'small',
    pageSize: 10,
    current: 1,
    showTotal,
    total: 0,
    showSizeChanger: false
  });

  const handleOpenModal = () => {
    setIsFormModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsFormModalVisible(false);
    setIsModalVistaQROpen(false);
    setSelectedRow(null);
  };

  const getImagesCierre = async (dataFrom, option) => {
    try {
      if (dataFrom !== null && dataFrom !== undefined) {
        setLoadingImages(true);
        const dataActaInicio = dataFrom.dataActaCierre.actas.find(
          (acta) => acta.idTipoActa === ACTA_INICIO
        );
        const payload = {
          acta: {
            idMonitoreo: '',
            idActa: ''
          }
        };
        payload.acta.idMonitoreo = dataFrom.dataActaCierre.actas[0].idMonitoreo;
        payload.acta.idActa = dataFrom.dataActaCierre.actas[0].idActa;
        const { data: dataImages } = await actasService.imagenes(payload);
        const dataActaWithImages = await useSetAddImages(dataImages.acta, dataActaInicio, option);
        const dataMonitoreo = {
          ...dataFrom,
          dataActaCierre: {
            ...dataFrom.dataActaCierre,
            actas: Array.isArray(dataActaWithImages) ? dataActaWithImages : [dataActaWithImages]
          }
        };
        if (option === 'new') {
          // setSelectedRow({ tableRow: dataMonitoreo, option });
          setDataFromQR(dataMonitoreo);
          timeoutId = setTimeout(() => {
            setLoadingImages(false); // Ocultar loader cuando la imagen ha terminado de subir
          }, 2000);
        }
      }
    } catch (error) {
      console.log('Error', error);
    }
  };

  const getImages = async (row, option) => {
    try {
      setLoadingImages(true);
      const dataActaInicio = row.actas.find((acta) => acta.idTipoActa === ACTA_INICIO);
      const payload = {
        acta: {
          idMonitoreo: '',
          idActa: ''
        }
      };
      payload.acta.idMonitoreo = row.idMonitoreo;
      payload.acta.idActa = row.actas[0].idActa;
      const { data: dataImages } = await actasService.imagenes(payload);
      const dataActaWithImages = await useSetAddImages(dataImages.acta, dataActaInicio, option);
      const dataMonitoreo = {
        ...row,
        actas: [dataActaWithImages]
      };
      if (option === 'edit') {
        setSelectedRow({ tableRow: dataMonitoreo, option });
        timeoutId = setTimeout(() => {
          setLoadingImages(false); // Ocultar loader cuando la imagen ha terminado de subir
        }, 2000);
      }
    } catch (error) {
      console.log('Error', error);
    }
  };

  const handleDataFromQR = (dataFrom) => {
    // setDataFromQR(dataFrom);
    getImagesCierre(dataFrom, 'new');
  };

  const handleCloseModalActaCierre = () => {
    setVisibleFormModalActaCierre(false);
  };

  const handleConfirmCancel = async (comments) => {
    const payload = {
      monitoreos: {
        toCancel: [
          {
            pkMonitoreo: monitoreoCancelar,
            idMonitoreo: monitoreoCancelar,
            motivoCancelacion: comments.motivo
          }
        ]
      }
    };
    const { success, response } = await dispatch(postEditMonEspectaculares(payload));
    if (success && response?.data.code === 200) {
      setMonitoreoCancelar(null);
      setSuccessCancelar(true);
      dispatch(
        getMonitoreosEspectacularesActaInicio(
          pagination.current,
          pagination.pageSize,
          folioActaInicio
        )
      );
    } else if (response?.causa !== undefined) {
      messageApi.error(response.causa);
    } else {
      messageApi.error(MensGrales.MAV1_2);
    }
  };

  const handleCancelMonitoring = (dataCancelacion) => {
    setMonitoreoCancelar(dataCancelacion);
  };

  const handleChangePageSize = (pageSize) => {
    setPagination((prevPagination) => ({ ...prevPagination, pageSize, current: 1 }));
  };

  const handleChangeFilter = ({ target }) => {
    const { value, name } = target;
    filtersRef.current[name] = value;
    applyFilter({ ...filtersRef.current });
  };

  const handleChangeDateFilter = (date) => {
    filtersRef.current.fechaRegistro = date;
    applyFilter({ ...filtersRef.current });
  };

  const callAction = (clickedRow, actionType) => {
    // const selectedDataRow = data.find((row) => row.folio === clickedRow.folio);
    if (actionType === 'qr') {
      setIsModalVistaQROpen(true);
      // selectedDataRow.fechaRegistro = JSON.stringify(selectedDataRow.fechaRegistro);
      // setDataQR(selectedDataRow);
    }

    if (actionType === 'edit') {
      // eslint-disable-next-line no-param-reassign
      clickedRow.actas[0].fiscalizacion = clickedRow.actas[0].fiscalizacion.map((servidor) => {
        if (!servidor.idUsuario) {
          return { ...servidor, idUsuario: 0 };
        }
        return servidor;
      });
      setIsFormModalVisible(true);
      setSelectedRow({ tableRow: clickedRow, actionType });
    }
  };

  const handleDownloadExcel = async () => {
    try {
      setDownloadingExcel(true);
      const payload = {
        cantidad: 10,
        pagina: 1,
        tipoMonitoreo: MONITOREOS_ESPECTACULARES,
        tipoActa: ACTA_INICIO
      };
      const { success, response } = await dispatch(downloadExcelActas(payload));
      if (success && response.data.excel64) {
        const url = window.URL.createObjectURL(
          base64toBlob(response.data.excel64.base64, response.data.excel64.tipo)
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', response.data.excel64.nombre);
        link.click();
        setDownloadingExcel(false);
      }
      setDownloadingExcel(false);
    } catch (error) {
      console.log('Error', error);
    }
  };

  const handleGetPdfActa = async (idMonitoreo, option, idActa) => {
    const payload = {
      tipoMonitoreo: MONITOREOS_ESPECTACULARES,
      tipoActa: ACTA_INICIO,
      tipoDescarga: DOWNLOAD_TYPES.TESTIGOS.value,
      listaIdMonitoreos: [idActa]
    };
    try {
      const { success, response } = await dispatch(getPdfActa(payload));

      const { archivo } = response.data;
      if (success) {
        setPdfActa(archivo);

        if (option === 'eyeOutlined') {
          setIsModalPdfOpen(true);
          setIsActaId(idActa);
          setIsMonitoreoId(idMonitoreo);
        }

        if (option === 'downloadOutlined') {
          DescargaPDF(archivo, PDF_ACTA_INICIO, idMonitoreo, idActa);
        }
      }
    } catch (error) {
      messageApi.error('Error al obtener el PDF', 3);
    }
  };

  const filter = (columnName, lblColumn) => (
    <label htmlFor={columnName}>
      {lblColumn}
      <Input
        id={columnName}
        placeholder="Escribe"
        name={columnName}
        key={columnName}
        onChange={handleChangeFilter}
      />
    </label>
  );

  const filterDate = (columnName, lblColumn) => (
    <label htmlFor={columnName}>
      {lblColumn}
      <DatePicker
        id={columnName}
        name={columnName}
        key={columnName}
        placeholder="Escribe"
        style={{ width: '100%' }}
        allowClear
        onChange={handleChangeDateFilter}
        format={DATE_FORMAT_DATE_PICKER}
      />
    </label>
  );

  const filteredList = useMemo(() => {
    const { fechaFinal, fechaInicio, folioDesde, folioHasta, idProcesoGral, idProcesoEspecifico } =
      mainFilters;
    const filteredData = data.filter((row) => {
      const folio = folioActaInicio ? getFolioNumber(folioActaInicio) : getFolioNumber(row.folio);
      if (folioDesde && folio < folioDesde) return false;
      if (folioHasta && folio > folioHasta) return false;
      if (idProcesoGral && row.idProcesoGral !== idProcesoGral) return false;
      if (idProcesoEspecifico && row.actas?.[0]?.idProcesoEspecifico !== idProcesoEspecifico)
        return false;
      if (fechaFinal && fechaFinal < row.fechaRegistro.format('YYYY-MM-DD 00:01:00.000'))
        return false;
      if (fechaInicio && fechaInicio > row.fechaRegistro.format('YYYY-MM-DD 00:01:00.000'))
        return false;
      return true;
    });
    return filteredData;
  });

  const checkBoxEstatusActa = (row) => {
    let enableCheckBox = false;
    if (row.estatusActa !== 'Validado' || row.actas[0].actaNotificada === NOTIFICADO) {
      enableCheckBox = true;
    }
    return enableCheckBox;
  };

  const onChange = (row, checked, optionType) => {
    switch (optionType) {
      case 'Descargas':
        if (checked) {
          // Si está marcado, agregar el row al checkedList
          setCheckedListDescargas((prevCheckedList) => [...prevCheckedList, row]);
        } else {
          // Si está desmarcado, filtrar el row fuera del checkedList
          setCheckedListDescargas((prevCheckedList) =>
            prevCheckedList.filter(
              (item) => !item.actas.some((acta) => acta.idActa === row.actas[0].idActa)
            )
          );
        }
        break;
      default:
        if (checked) {
          // Si está marcado, agregar el row al checkedList
          setCheckedListNotificar((prevCheckedList) => [...prevCheckedList, row]);
        } else {
          // Si está desmarcado, filtrar el row fuera del checkedList
          setCheckedListNotificar((prevCheckedList) =>
            prevCheckedList.filter(
              (item) => !item.actas.some((acta) => acta.idActa === row.actas[0].idActa)
            )
          );
        }
    }
  };

  const handleSetProcesarTodo = (valor) => {
    try {
      if (onProcesarTodoChange) {
        onProcesarTodoChange(valor);
      }
    } catch (error) {
      console.log('Error: ', error);
    }
  };

  const onCheckAllChange = (e, optionType) => {
    const newSeleccion = {};
    const newNotificar = {};
    switch (optionType) {
      case 'Descargas':
        if (e.target.checked) {
          allOptions.forEach((item) => {
            newSeleccion[item.idForDescarga] = true;
          });
          // eslint-disable-next-line no-param-reassign
          seleccion.current = newSeleccion;
          handleSetProcesarTodo(true);
        } else {
          allOptions.forEach((item) => {
            newSeleccion[item.idForDescarga] = false;
          });
          // eslint-disable-next-line no-param-reassign
          seleccion.current = newSeleccion;
          handleSetProcesarTodo(false);
        }
        setCheckedListDescargas(e.target.checked ? allOptions : []);
        break;

      default:
        if (e.target.checked) {
          allOptionsNotificar.forEach((item) => {
            newNotificar[item.idForNotificar] = true;
          });
          notificadosParcialmente.forEach((item) => {
            newNotificar[item.idForNotificar] = true;
          });
        } else {
          allOptionsNotificar.forEach((item) => {
            newNotificar[item.idForNotificar] = false;
          });
          notificadosParcialmente.forEach((item) => {
            newNotificar[item.idForNotificar] = false;
          });
        }
        notificar.current = newSeleccion;
        setCheckedListNotificar(e.target.checked ? allOptionsNotificar : []);
    }
  };

  const checkAll = (columnName, lblColumn) => (
    <label className="checkAll" htmlFor={columnName}>
      {lblColumn}
      <Checkbox
        className="checkboxAll"
        indeterminate={indeterminateDescargas}
        onChange={(e) => onCheckAllChange(e, 'Descargas')}
        checked={checkAllOptionsDescargas}
        disabled={allOptions.length === 0}
      />
    </label>
  );

  const checkAllNotificar = (columName, lblColumn) => (
    <label className="checkAll" htmlFor={columName}>
      {lblColumn}
      <Checkbox
        className="checkboxAll"
        indeterminate={indeterminateNotificar}
        onChange={(e) => onCheckAllChange(e, 'Notificar')}
        checked={checkAllOptionsNotificar}
        disabled={allOptionsNotificar.length === 0}
      />
    </label>
  );

  const renderCheckboxDescarga = (_, row) => (
    <Checkbox
      checked={!!seleccion.current[row.idForDescarga]}
      key={row.idForDescarga}
      onChange={({ target }) => {
        const { current } = seleccion;
        current[row.idForDescarga] = target.checked;
        onChange(row, target.checked, 'Descargas');
      }}
    />
  );

  const renderCheckboxNotificar = (_, row) => {
    // MNI - Se agrega a la condición la variable tienePermisoNotificar ya que los usuarios de Rol "VALIDADOR"
    // No podian enviar Notificaciones a Partidos
    if (tienePermisoValidar || tienePermisoEditar || tienePermisoNotificar) {
      return (
        <Checkbox
          checked={
            !!notificar.current[row.idForNotificar] ||
            row.actas[0]?.actaNotificada === PARCIALMENTE_NOTIFICADO ||
            row.actas[0]?.actaNotificada === NOTIFICADO
          }
          disabled={checkBoxEstatusActa(row)}
          key={row.idForNotificar}
          onChange={({ target }) => {
            const { checked } = target;
            const { current } = notificar;
            current[row.idForNotificar] = checked;
            onChange(row, target.checked, 'Notificar');
          }}
        />
      );
    }
    return <Checkbox disabled />;
  };

  const renderActions = (_, row) => (
    <div className="actions-container">
      <Tooltip
        title="Consultar"
        className="tooltip-acciones btn-deleteoutlined"
        placement="topLeft"
        arrow={{ pointAtCenter: true }}>
        <Button
          type="primary"
          onClick={() => {
            messageApi.open({
              content: <Spin />
            });
            const { idMonitoreo, idActa } = row.actas[0];
            handleGetPdfActa(idMonitoreo, 'eyeOutlined', idActa);
          }}
          icon={<EyeOutlined />}
          ghost
        />
      </Tooltip>

      {((tienePermisoEditar && row.actas[0]?.estatus === 2 && row.estatusMonitoreo !== 3) ||
        (tienePermisoEditar && row.estatusMonitoreo !== 3 && row.actas[0]?.estatus !== 3) ||
        usuario.rol.includes('SIMAC.ADMIN.OC')) && (
        <Tooltip
          title="Editar"
          className="tooltip-acciones btn-deleteoutlined"
          placement="topLeft"
          arrow={{ pointAtCenter: true }}>
          <Button
            type="primary"
            onClick={() => {
              callAction(row, 'edit');
              getImages(row, 'edit');
            }}
            icon={<EditOutlined />}
            ghost
          />
        </Tooltip>
      )}

      {getMenuPermissions(
        menu,
        NOMBRE_MENU_ESPECTACULARES,
        NOMBRE_SUBMENU_ACTAS_INICIO,
        NOMBRE_MENU_PERMISO_QR
      ) &&
        row.estatusMonitoreo !== 3 &&
        row.actas[0].estatus !== 3 && (
          <Tooltip
            title="QR"
            className="tooltip-acciones btn-deleteoutlined"
            placement="topLeft"
            arrow={{ pointAtCenter: true }}>
            <Button
              type="primary"
              onClick={() => {
                callAction({ folio: row.folio }, 'qr');
                setDataQR(row);
              }}
              icon={<QrcodeOutlined className="icons-tbl-users" />}
              ghost
            />
          </Tooltip>
        )}

      <Tooltip
        title="Descargar"
        className="tooltip-acciones btn-deleteoutlined"
        placement="topLeft"
        arrow={{ pointAtCenter: true }}>
        <Button
          type="primary"
          onClick={() => {
            messageApi.open({
              content: <Spin />
            });
            const { idMonitoreo, idActa } = row.actas[0];
            handleGetPdfActa(idMonitoreo, 'downloadOutlined', idActa);
          }}
          icon={<DownloadOutlined />}
          ghost
        />
      </Tooltip>

      {((getMenuPermissions(
        menu,
        NOMBRE_MENU_ESPECTACULARES,
        NOMBRE_SUBMENU_ACTAS_INICIO,
        NOMBRE_MENU_PERMISO_ELIMINAR
      ) &&
        row.actas[0]?.estatus === 2) ||
        (tienePermisoEditar && row.estatusMonitoreo !== 3 && row.actas[0]?.estatus !== 3)) && (
        <Tooltip
          title="Cancelar"
          className="tooltip-acciones btn-deleteoutlined"
          placement="topLeft"
          arrow={{ pointAtCenter: true }}>
          <Button
            shape="circle"
            onClick={() => {
              handleCancelMonitoring(row.idMonitoreo);
              setFolioCancelar(row.folio);
            }}
            icon={<CloseCircleOutlined className="icons-tbl-users" />}
          />
        </Tooltip>
      )}
    </div>
  );

  const columns = [
    {
      title: filter('folio', 'Folio de monitoreo:'),
      dataIndex: 'folio',
      width: '15%',
      key: 'folio'
    },
    {
      title: filter('monitor', 'Monitorista'),
      dataIndex: 'monitor',
      width: '17%',
      key: 'monitor'
    },
    {
      title: filter('estado', 'Entidad'),
      dataIndex: 'estado',
      width: '12%',
      key: 'estado'
    },
    {
      title: filterDate('fechaRegistroCadena', 'Fecha de registro'),
      dataIndex: 'fechaRegistroCadena',
      width: '12%',
      key: 'fechaRegistroCadena'
    },
    {
      title: filter('estatusActa', 'Estatus'),
      dataIndex: 'estatusActa',
      width: '10%',
      key: 'estatusActa'
    },
    {
      title: checkAllNotificar('notificado', 'Notificar a partido'),
      dataIndex: 'notificado',
      align: 'center',
      render: renderCheckboxNotificar,
      width: '8%',
      key: 'notificado'
    },
    {
      title: checkAll('descargado', 'Check de descarga'),
      dataIndex: 'descargado',
      align: 'center',
      render: renderCheckboxDescarga,
      width: '8%',
      key: 'descargado'
    },
    {
      title: 'Acciones',
      dataIndex: 'actions',
      align: 'center',
      width: '10%',
      key: 'actions',
      render: renderActions
    }
  ];

  const allowedColumns = useMemo(() => {
    if (
      !getMenuPermissions(
        menu,
        NOMBRE_MENU_ESPECTACULARES,
        NOMBRE_SUBMENU_ACTAS_INICIO,
        NOMBRE_MENU_PERMISO_NOTIFICAR
      )
    ) {
      return columns
        .map((column) => (column.key.includes('notificado') ? null : column))
        .filter((column) => column !== null);
    }
    return columns;
  }, [checkedListNotificar, checkedListDescargas]);

  const getDataActaInicio = async () => {
    try {
      const { success, totalActas } = await dispatch(
        getMonitoreosEspectacularesActaInicio(
          pagination.current,
          pagination.pageSize,
          folioActaInicio
        )
      );
      if (success && totalActas > 0) {
        setPagination((prev) => ({
          ...prev,
          total: totalActas
        }));
        // Check para descarga
        // Cada que cambia la paginación reiniciamos los check a false
        const event = { target: { checked: false } };
        onCheckAllChange(event, 'Notificar');
        onCheckAllChange(event, 'Descargas');
      }
    } catch (error) {
      console.log('Error', error);
    }
  };

  const onClickButtonNotificarOGenerar = () => {
    notificadosParcialmente.forEach((item) => {
      notificar.current[item.idForNotificar] = true;
    });
    // console.log('notificar', notificar);
  };

  useEffect(() => {
    getDataActaInicio();
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
  }, [pagination.current, pagination.pageSize, folioActaInicio]);

  useEffect(() => {
    if (checkedListNotificar?.length === 0 || notificadosParcialmente?.length === 0) {
      setDisableButtonNotificar(true);
    }
    if (checkedListNotificar?.length > 0 || notificadosParcialmente?.length > 0) {
      setDisableButtonNotificar(false);
    }
  }, [checkedListNotificar]);

  const dataList = useMemo(() => {
    return filterList(filteredList, filters);
  }, [filteredList, filters]);
  // console.log("Check's", seleccion, notificar);

  return (
    <div className="tabla-monitoreo">
      <ModalFormularioActaInicio
        visible={isFormModalVisible}
        onClose={handleCloseModal}
        initialData={selectedRow}
        loadingImages={loadingImages}
        filtroFolioActaInicio={folioActaInicio}
        pagina={pagination.current}
        pageSize={pagination.pageSize}
      />
      <ModalPdf
        open={isModalPdfOpen}
        pdfActa={pdfActa}
        tipoActa={PDF_ACTA_INICIO}
        callback={() => setIsModalPdfOpen(false)}
        idActa={isActaId}
        idMonitoreo={isMonitoreoId}
        destroyOnClose
      />
      {/* <ModalVistaQR
        open={isModalVistaQROpen}
        callback={() => setIsModalVistaQROpen(false)}
        dataActa={dataQR}
        sata
        actaType={ACTA_INICIO}
        onClose={handleCloseModal}
        destroyOnClose
      /> */}
      <ModalCodigoQR
        open={isModalVistaQROpen}
        callback={() => setIsModalVistaQROpen(false)}
        onClose={handleCloseModal}
        destroyOnClose
        crearActaCierre={(dataFrom) => {
          handleDataFromQR(dataFrom);
          setVisibleFormModalActaCierre(true);
        }}
        dataQr={dataQR}
      />
      <ModalFormularioActaCierre
        visible={visibleFormModalActaCierre}
        onClose={handleCloseModalActaCierre}
        initialDataNewActaCierre={dataFromQR}
        pagina={1}
        pageSize={10}
      />
      <ModalNotificarPartido
        visible={visibleModalNotificar}
        seleccion={notificar}
        tipo={TIPO_ACTA_INICIO}
        onClose={() => setVisibleModalNotificar(false)}
        getMonitoreos={getDataActaInicio}
      />
      <div>
        <CancelModalMonitoring
          open={monitoreoCancelar}
          title={
            <>
              Se cancelará el monitoreo asociado a esta acta.
              <br />
              ¿Estás seguro de cancelar el Acta de inicio
              <br />
              {folioCancelar}?
            </>
          }
          cancelConfirm={handleConfirmCancel}
          handleCerrar={() => {
            setMonitoreoCancelar(null);
            setSuccessCancelar(false);
          }}
          openSuccess={successCancelar}
        />
      </div>
      <div className="table-header">
        <div>
          <SelectTamanoPagina
            value={pagination.pageSize}
            onChange={handleChangePageSize}
            disableBottomExcel={downloadingExcel}
            onClick={handleDownloadExcel}
          />
        </div>
        {getMenuPermissions(
          menu,
          NOMBRE_MENU_ESPECTACULARES,
          NOMBRE_SUBMENU_ACTAS_INICIO,
          NOMBRE_MENU_PERMISO_CAPTURAR
        ) && <Button text="Agregar acta de inicio" type="primary" onClick={handleOpenModal} />}
      </div>
      {contextHolder}
      <Table
        bordered={false}
        columns={allowedColumns}
        dataSource={dataList}
        pagination={{
          ...pagination,
          onChange: (page, pageSize) => {
            setPagination((prev) => ({
              ...prev,
              current: page,
              pageSize: pageSize || prev.pageSize
            }));
          }
        }}
        loading={loading}
        rowKey={generateId()}
      />
      {getMenuPermissions(
        menu,
        NOMBRE_MENU_ESPECTACULARES,
        NOMBRE_SUBMENU_ACTAS_INICIO,
        NOMBRE_MENU_PERMISO_NOTIFICAR
      ) && (
        <div className="contenedorBtns">
          <div className="btnNotificar">
            <Button
              onClick={() => {
                onClickButtonNotificarOGenerar();
                setVisibleModalNotificar(true);
              }}
              size="large"
              type="primary"
              text="Enviar notificación"
              icon={<BellOutlined />}
              disabled={disableButtonNotificar || loading}
            />
          </div>
          <div className="btnGenerar">
            <DescripcionEnlacesModal
              seleccion={notificar}
              tipoMonitoreo={MONITOREOS_ESPECTACULARES}
              tipoActa={ACTA_INICIO}
              disabledButton={disableButtonNotificar || loading}
              onUpdateSeleccion={onClickButtonNotificarOGenerar}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default TablaMonitoreos;

TablaMonitoreos.propTypes = {
  mainFilters: PropTypes.shape({
    fechaFinal: PropTypes.shape({}),
    fechaInicio: PropTypes.shape({}),
    folioDesde: PropTypes.number,
    folioHasta: PropTypes.number,
    idProcesoGral: PropTypes.number,
    idProcesoEspecifico: PropTypes.number
  }).isRequired,
  seleccion: PropTypes.shape({
    current: PropTypes.shape({})
  }).isRequired
};
